import { defineStore } from 'pinia';
import type { ActivityType } from '@lw-modules/onboarding-platform';
import { EntityType } from '~/enums/accounts/entity-type.enum';
import type { ProfileStatusType } from '~/enums/accounts/profile-status-type.enum';
import { useSettingsFormStore } from '~/stores/accounts/add-account/settings-form-store';

export const useAddAccountStore = defineStore('add-account', {
  state: () => ({
    currentStep: 1,
    entityType: undefined as EntityType | undefined,
    isIndividualModalOpen: false as boolean,
    isLegalEntityModalOpen: false as boolean,
    isNewAccountCreated: false as boolean,
    newAccountId: undefined as string | undefined,
    newAccountProfileStatus: undefined as ProfileStatusType | undefined
  }),

  actions: {
    openModal(type: EntityType, activity: ActivityType) {
      const { activityType } = storeToRefs(useSettingsFormStore());

      activityType.value = activity;
      this.entityType = type;
      this.currentStep = 1;

      if (type === EntityType.Individual) {
        this.isIndividualModalOpen = true;
      } else if (type === EntityType.LegalEntity) {
        this.isLegalEntityModalOpen = true;
      }
    }
  }
});
